interface SecurityInfraCostList {
  [key: string]: number[];
}
// ----------------------------------------------------------------------
export const _securityInfra_cost_list: SecurityInfraCostList = {
  security_overhead_0: [250000, 1200000, 450000, 1600000, 350000, 750000, 0, 250000],
  security_overhead_1: [261250, 1254000, 470250, 1672000, 365750, 783750, 0, 261250],
  security_overhead_2: [273006, 1310430, 491411, 1747240, 382209, 819019, 0, 273006],
  security_overhead_3: [285292, 1369399, 513525, 1825866, 399408, 855875, 0, 285292],
  security_overhead_4: [298130, 1431022, 536633, 1908030, 417382, 894389, 0, 298130],
  security_overhead_5: [311545, 1495418, 560782, 1993891, 436164, 934636, 0, 311545],
  security_overhead_6: [325565, 1562712, 586017, 2083616, 455791, 976695, 0, 325565],
  security_overhead_7: [340215, 1633034, 612388, 2177379, 476302, 1020646, 0, 340215],
  security_overhead_8: [355525, 1706521, 639945, 2275361, 497735, 1066575, 0, 355525],
  security_overhead_9: [371524, 1783314, 668743, 2377752, 520133, 1114571, 0, 371524],
};
